import { createContext, ReactNode, useContext } from 'react';
import { Button } from '@fluentui/react-components';

import { AuthContext, useSignIn } from '@modules/users';
import { StatusLabel } from '@shared/components';
import { toApiException } from '@shared/helpers';
import type { TSigninReturn } from '../types/users.types';

type TProps = {
  children: ReactNode;
};

// @ts-ignore
const SignInContext = createContext<TSigninReturn>();
export default SignInContext;

export const SignInProvider = ({ children }: TProps) => {
  const { logout } = useContext(AuthContext);
  const { error, data } = useSignIn();

  if (!data && error) {
    let message = 'Sign-in failed.';
    const apiError = toApiException(error);
    if (apiError) {
      if (apiError.message) message = apiError.message;
    }

    return (
      <div className="p-4">
        <p className="mb-2 text-lg">
          <strong className="font-medium">Error:</strong> {message}
        </p>
        <Button onClick={logout}>Logout</Button>
      </div>
    );
  }

  return (
    <StatusLabel
      data={data}
      loadingMessage="Signing you in..."
      render={(data) => (
        <SignInContext.Provider
          value={{
            user: data.user,
            organization: data.organization,
            folderAccess: data.folderAccess,
          }}
        >
          {children}
        </SignInContext.Provider>
      )}
    />
  );
};
